import { gql } from '@apollo/client';

export const updateNoteEntry = gql`
  mutation updateNoteEntry($id: String, $entryTime: Int, $entryText: String) {
    updateNoteEntry(id: $id, entryTime: $entryTime, entryText: $entryText) {
      controllerNotesId
      createdAt
      createdBy
      deletedAt
      id
      note
      time
      updatedAt
      updater
      version
    }
  }
`;
